import { createIcon } from '@chakra-ui/icon'

export const StarOutlineIcon = createIcon({
  displayName: 'StarOutlineIcon',
  viewBox: '0 0 20 20',
  path: (
    <path
      d="M8.49996 1.41669L10.6887 5.85085L15.5833 6.56627L12.0416 10.0159L12.8775 14.8892L8.49996 12.5871L4.12246 14.8892L4.95829 10.0159L1.41663 6.56627L6.31121 5.85085L8.49996 1.41669Z"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
})
